import { Component, OnInit, Input, ElementRef, ViewChild, ChangeDetectionStrategy, HostListener } from '@angular/core';
import { FormGroup } from '@angular/forms';

import { InterfaceElement, IEUserAction, IEValue} from 'src/app/model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { UXControllerService } from 'src/app/service/controller/ux-controller.service';
import { CosyHtmlElementGenerationService } from 'src/app/service/generator/generator-html/cosy-html-element-generation.service';
import { CosyCommunicationControllerService } from 'src/app/service/controller/cosy-communication-controller.service';
import { InterfaceElementDefaults } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-default';
import { InterfaceElementTypes } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-type';
import { TreeUseractions } from 'src/app/model/useraction/task-useraction/tree-useractions';
import { InterfaceElementTemplate } from 'src/app/model/interfaceElement/interfaceElement-properties/interfaceElement-template';
import { Console } from 'console';

@Component({
  selector: 'app-cosy-picklist',
  templateUrl: './cosy-picklist.component.html',
  styleUrls: ['./cosy-picklist.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CosyPicklistComponent implements OnInit {
  @ViewChild('ieoption') ieoption: ElementRef;
  @Input() ie: InterfaceElement;
  @Input() formgroup: FormGroup = null;
  @Input() label: boolean = false;
  @Input() RTKeyShowNullable:boolean = false;
  @Input() formType: any;
  @Input() languageOptions:any[]=[];
  
  private ua: IEUserAction = new IEUserAction();
  public listOptions : any = [];
  public selectAllValues : any = [];
  private values: any[] = [];
  public selectedOptions = [];

  public IE_TYPES = InterfaceElementTypes;
  public ieValue: any = '';
  public ieInputKey: any = '';
  public ieInput
  public selectedLanguageCodeID: string = "";
  public selectAllTextShort : string = "";
  public resizeId;
  public isResizeDone: boolean = false;

  constructor(
              private uxControllerService: UXControllerService,
              private cosyHtmlElementGenerationService: CosyHtmlElementGenerationService,
              private cosyCommunicationControllerService : CosyCommunicationControllerService) { }

              @HostListener('window:resize', ['$event'])
              onResize(event) {
                if(this.ieInputKey!=null && this.ie.TypeDID == InterfaceElementTypes.InputValuePicklist ){
                  let index = this.ie.DynamicMetaData.Items.map(function(e){return e.ID}).indexOf(this.ieInputKey);
                  if(index>-1 && this.ie.DynamicMetaData.Items[index].DisplayName == 'auto'){
                    this.fetchIEUserAction(this.ie.Attributes.OnSelectUAID, this.ie.DynamicMetaData.Items[index].DisplayName, null, null, null, null, null);
                  }
                }
              //  clearTimeout(this.resizeId);
              //  let uaid = this.ie.Attributes.OnSelectUAID;
              //  this.resizeId = setTimeout(this.fetchIEUserAction, 200,uaid,'auto',null, null, null, null, null, this.ie, this.uxControllerService);
               // this.resizeId = setTimeout(() => {
               //   console.log('Resize done')
               // }, 200);
               // clearTimeout(this.resizeId);
               // let uaid = this.ie.Attributes.OnSelectUAID;
               // this.resizeId = setTimeout(function() { this.fetchIEUserAction(uaid, 'auto', null, null, null, null, null) }, 300);
               // this.resizeId = setTimeout(this.doneResizing, 200,this.ieInputKey, this.ie);
                //console.log('here resizeDone: ', this.isResizeDone)
                
                /*if(this.ieInputKey!=null && this.ie.TypeDID == InterfaceElementTypes.InputValuePicklist ){
                  let index = this.ie.DynamicMetaData.Items.map(function(e){return e.ID}).indexOf(this.ieInputKey);
                  if(index>-1 && this.ie.DynamicMetaData.Items[index].DisplayName == 'auto'){
                    if(this.uxControllerService.ieEntityList.Values== null){
                      this.uxControllerService.ieEntityList.Values = [];
                    }
                    this.fetchIEUserAction(this.ie.Attributes.OnSelectUAID, this.ie.DynamicMetaData.Items[index].DisplayName, null, null, null, null, null);
                  }
                }*/
              }
              

  ngOnInit() {
    this.listOptions = []; 
    this.values= [];
    this.selectedLanguageCodeID = this.cosyCommunicationControllerService.langFromServer['value'];
    this.selectAllTextShort = this.cosyCommunicationControllerService.selectAllText['value'];
    

    /*if(this.formgroup != null && this.ie.CustomizeOptions!= null && this.ie.CustomizeOptions.Multiple == 'multiple'){ 
      this.ie.FormControlProperties = new IEFormControlProperties();
      this.ie.FormControlProperties.Disabled = this.formgroup.controls[this.ie.InterfaceElementID].disabled;
    }*/
    
    if(this.ie.TemplateID == InterfaceElementTemplate.RecordPerPageTemplate && this.ie.Values.length == 0){
      let ieValue = new IEValue();
      ieValue.Value = this.uxControllerService.ieEntityList.Attributes.RowsPerPage.toString();
      this.ie.Values.push(ieValue); 
    }

    if(this.ie.TypeDID == InterfaceElementTypes.InputPicklist || this.ie.TypeDID == InterfaceElementTypes.InputValuePicklist) {
      if (this.formType == InterfaceElementTypes.FormEntity || 
        this.formType == InterfaceElementTypes.Tab || 
        this.formType == InterfaceElementTypes.Group) {
        this.ie.DynamicMetaData.Items.forEach(item => {
          if (item.Visible) {
            this.listOptions.push({key:item.ID, value: item.DisplayName});
          }
          if (this.ie.Values != null && this.ie.Values.length > 0 && item.ID == this.ie.Values[0].Value) {
            this.ie.Values[0].Value = item.ID;
          }
        });
      } else if (this.formType === InterfaceElementTypes.UXController) {
          this.ie.UserActions.forEach(useraction => {
          this.listOptions.push({key: useraction.UserActionID, value:useraction.Name});
          if (this.ie.Values != null && this.ie.Values.length > 0 && useraction.UserActionID == this.ie.Values[0].Value) {
            this.ie.Values[0].Value = useraction.UserActionID;
          }
        });
      } else if(this.formType == null){
        this.ie.DynamicMetaData.Items.forEach(item => {
            this.listOptions.push({key:item.ID, value: item.DisplayName});
        });

      }
    
      if (this.ie.Values != null && this.ie.Values.length > 0) {
        this.ieValue = this.ie.Values[0].Value;
        if(this.ie.TypeDID == InterfaceElementTypes.InputValuePicklist){   
          let recValueIndex = this.ie.DynamicMetaData.Items.map(function(e){return e.DisplayName}).indexOf(this.ieValue);
          if(recValueIndex<0){
            this.ieInputKey = this.ie.DynamicMetaData.Items[0].ID;
            this.ieValue = this.ie.DynamicMetaData.Items[0].DisplayName;
          } else if(recValueIndex >-1){
            this.ieInputKey = this.ie.DynamicMetaData.Items[recValueIndex].ID;
          }
        } else {
          if (this.cosyCommunicationControllerService.RTKeyShowNullable)
          {
            this.ie.Values[0].Value = this.ie.Values[0].nil ? '' : this.ie.Values[0].Value;
          }
          else this.ie.Values[0].Value = this.ie.Values[0].nil ? InterfaceElementDefaults.InputPicklistDefault : this.ie.Values[0].Value;
            this.ieValue = this.ie.Values[0].Value;
        } 
      }
      
      this.values = this.ieValue;

      if(this.ie.CustomizeOptions!= null && this.ie.CustomizeOptions.Multiple!=null){ 
        this.ie.CustomizeOptions.Size = 'height:'+this.ie.CustomizeOptions.Size+'em';
        if(this.ie.Values.length>0 && this.ie.Values[0].Value == InterfaceElementDefaults.InputPicklistDefault){
          this.values = null;
        }
        else {
          this.values = [];
          if(this.listOptions.length>0){
            for(let v of this.ie.Values){
              if(!v.nil && v.Value!== ''){
                let i = this.listOptions.map(item=>item.key).indexOf(v.Value);
                this.selectedOptions.push(this.listOptions[i].key);
                this.values.push(this.listOptions[i].key);
              }
            }
          } 
        }
      }
    
      if (this.ie.Attributes.OnSelectUAID == null) {
        this.ua =  this.cosyHtmlElementGenerationService.generateInlineUAID(this.ie.TypeDID, null);
        this.ie.UserActions.push(this.ua);
        this.ie.Attributes.OnSelectUAID = this.ua.UserActionID;
      }
    }
  }

  ngOnChanges(){
   
    if(this.ie.TypeDID == InterfaceElementTypes.InputValuePicklist){
      //console.log('Values: ', this.ie.Values)
      /*if( value == 'auto'){
        value = this.uxControllerService.calculateAutoGridRowNumber(window.innerHeight, this.uxControllerService.autoGridRowHeight);
      }*/
    }

  }

  /*doneResizing(inputKey, currentIE: InterfaceElement){
   
    this.isResizeDone = true;
    console.log(inputKey);
    console.log(currentIE);
    if(inputKey!=null && currentIE.TypeDID == InterfaceElementTypes.InputValuePicklist ){
      let index = currentIE.DynamicMetaData.Items.map(function(e){return e.ID}).indexOf(inputKey);
      if(index>-1 && currentIE.DynamicMetaData.Items[index].DisplayName == 'auto'){
        this.fetchIEUserAction(currentIE.Attributes.OnSelectUAID, currentIE.DynamicMetaData.Items[index].DisplayName, null, null, null, null, null);
      }
    }
  }*/

  onOptionSelect(option: any,
    isSelected: boolean){
      
    let values: any[] = [];
    let nilIndex = -1;
   
    if(this.values == null) this.values=[];
    if(this.values!= null && this.values.length > 0) nilIndex = this.ie.Values.findIndex((element) => element.nil == true);

    let i = this.values.indexOf(option.key);
    if(isSelected){
      if(nilIndex>-1) this.values.splice(nilIndex,1);
      if(i<0) this.values.push(option.key);
    } else if(!isSelected){
     if(i>-1) this.values.splice(i,1);
    }
    if (this.values.length == 0) {values.push({nil:true})}
    else values = this.values;
    this.fetchIEUserAction(this.ie.Attributes.OnSelectUAID, values, null, null, null, this.formgroup, null);
  }

  onAllOptionSelect(cb){
     this.selectAllValues = [];
     if(this.values == null ) this.values= [];
     

     if(cb == true){
      for(let lo of this.listOptions){
    
        let value = new IEValue();
       
        value.Value = lo.key;
        value.Checked = true;
        value.Marked = true;
  
        this.ie.Values.push(value);
        this.selectAllValues.push(lo.key);
      }
     }
    else if(cb == false){
      let value = new IEValue();
      value.nil = true;
      this.selectAllValues.push(value);
  }
  this.values = this.selectAllValues;
    
   this.fetchIEUserAction(this.ie.Attributes.OnSelectUAID,  this.values, null, null, null, this.formgroup, null);
  }

  getAllSelectedOption(ievalues: any[], cb){

    if(this.ie.Values.length == this.listOptions.length){
      if(this.ie.Values.length == 1 && this.ie.Values[0].Value == InterfaceElementDefaults.InputPicklistDefault){
        return false;
      } else {
        return true;
      }
    }else  {
      return false;
    }

  }
  getSelectedOption(ievalues: any[], optionKey){
    let selectedIndex: number = -1;
    selectedIndex = ievalues.map(function(e){return e.Value}).indexOf(optionKey);
    if(selectedIndex>-1){
      return true;
    } else return false;

  }
  
  fetchIEUserAction(userActionID: string, value: any, attributeKey: string, additionalAttributes: any[], 
    additionalInterfaceElements: InterfaceElement[], formgroup: FormGroup, multiselect: boolean) {
    
    if(this.ie.TypeDID == InterfaceElementTypes.InputValuePicklist){
      if( value == 'auto'){
        value = this.uxControllerService.calculateAutoGridRowNumber(window.innerHeight, this.uxControllerService.autoGridRowHeight);
      }
    }
    console.log('Value: ', value);
    if (userActionID != null) {
      if (this.ie.Attributes.Nullable && value == InterfaceElementDefaults.InputPicklistDefault && 
        this.formgroup.get(this.ie.InterfaceElementID + '_null') != null) {
       // this.formgroup.get(this.ie.InterfaceElementID + '_null').setValue(true);
        if (this.RTKeyShowNullable) {
          //this.formgroup.get(this.ie.InterfaceElementID).disable();
          //this.formgroup.get(this.ie.InterfaceElementID).setValue('');
        }
      }
      else if (this.ie.Attributes.Nullable && 
               value != InterfaceElementDefaults.InputPicklistDefault && 
               this.formgroup.get(this.ie.InterfaceElementID + '_null') != null) {
                this.formgroup.get(this.ie.InterfaceElementID + '_null').setValue(false);
              }
               
     // 
        if( (value.length> 0 && value[0].nil == true ) || value == 'niltrue'){
          this.uxControllerService.fetchIEUserAction(userActionID,
            this.ie,
           'niltrue',
           attributeKey,
           additionalAttributes,
           additionalInterfaceElements,
           formgroup,
           multiselect);
        } 
        else {
          if(this.ie.TypeDID == InterfaceElementTypes.InputValuePicklist){ 
            this.uxControllerService.fetchIEUserAction
            (
              this.uxControllerService.ieEntityList.Attributes.OnPagerUAID,
              this.uxControllerService.ieEntityList,
              value,
              'RowsPerPage',
              additionalAttributes,
              additionalInterfaceElements,
              formgroup,
              multiselect
            );
          }
          this.uxControllerService.fetchIEUserAction
            (
              userActionID,
              this.ie,
              value,
              attributeKey,
              additionalAttributes,
              additionalInterfaceElements,
              formgroup,
              multiselect
            );
        }

       /* if (value != InterfaceElementDefaults.InputPicklistDefault)
         {        
            if(this.ie.TypeDID == InterfaceElementTypes.InputValuePicklist){ 
              this.uxControllerService.fetchIEUserAction
              (
                this.uxControllerService.ieEntityList.Attributes.OnPagerUAID,
                this.uxControllerService.ieEntityList,
                value,
                'RowsPerPage',
                additionalAttributes,
                additionalInterfaceElements,
                formgroup,
                multiselect
              );
            }
            this.uxControllerService.fetchIEUserAction
              (
                userActionID,
                this.ie,
                value,
                attributeKey,
                additionalAttributes,
                additionalInterfaceElements,
                formgroup,
                multiselect
              );
         }
      else
         { 
          this.uxControllerService.fetchIEUserAction(userActionID,
             this.ie,
            'niltrue',
            attributeKey,
            additionalAttributes,
            additionalInterfaceElements,
            formgroup,
            multiselect);
        }*/
    }
  }
}
